import { Component } from '@angular/core';

@Component({
  selector: 'app-overviews',
  imports: [],
  templateUrl: './overviews.html',
  styleUrl: './overviews.css',
})
export class Overviews {

}
